import React from "react";

const myTrips = () => {
  return <div>myTrips</div>;
};

export default myTrips;
